/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createCustomerProfile} from '../api'

export const useMutationCreateCustomerProfile = createReactQueryMutationHook('createCustomerProfile', createCustomerProfile)
